import { Autocomplete } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const CustomTextField = styled("input")(
  () => `
  transition: 0.2s ease-in-out all;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid var(--border-color, #E7EBF0);
  background-color: var(--card-bg, #000B1808);
  outline: 0;

  &:hover {
    border-color: var(--accent, #443DF6);
  }

  &:focus {
    border-color: var(--accent, #443DF6);
    box-shadow: 0 0 0 3px rgba(74, 106, 255, 0.14);
    -webkit-box-shadow: 0 0 0 3px rgba(74, 106, 255, 0.14);
    -moz-box-shadow: 0 0 0 3px rgba(74, 106, 255, 0.14);
  }

  &.error {
    border-color: var(--error, #D3302F);
    box-shadow: 0 0 0 3px rgba(211, 48, 47, 0.18);
    -webkit-box-shadow: 0 0 0 3px rgba(211, 48, 47, 0.18);
    -moz-box-shadow: 0 0 0 3px rgba(211, 48, 47, 0.18);
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }

  @media screen and (max-width: 600px) {
    font-size: 0.75rem;
    padding: 8px 10px;
  }
  
  @media screen and (max-width: 400px) {
    font-size: 0.625rem;
    padding: 6px 8px;
  }
`
);
// export const CustomTextField = styled(TextField)(({ theme }) => ({
//   "& .MuiOutlinedInput-root": {
//     transition: "0.2s ease-in-out all",

//     borderRadius: "6px",
//     backgroundColor: "#000B1808",
//     "& .MuiOutlinedInput-notchedOutline": {
//       border: "none",
//     },
//   },
//   "& .MuiOutlinedInput-root.Mui-focused": {
//     border: `1px solid ${alpha(theme.palette.primary.main, 1)}`,
//     boxShadow: `${alpha(theme.palette.primary.main, 0.2)} 0 0 0 0.2rem`,
//   },
//   "& .MuiOutlinedInput-root.Mui-error": {
//     border: `1px solid red`,
//     boxShadow: `#F005 0 0 0 0.2rem`,
//   },

//   "& .MuiInputLabel-root": {
//     display: "none",
//     "&:focus": {
//       boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
//       borderColor: theme.palette.primary.main,
//     },
//   },
//   "& .MuiOutlinedInput-input": {
//     fontSize: "0.9rem",
//     padding: "11px 14px",
//   },

//   [theme.breakpoints.down("sm")]: {
//     "& .MuiOutlinedInput-input": {
//       fontSize: "0.8rem",
//       padding: "10px 12px",
//     },
//   },
// }));

export const CustomAutoComplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    transition: "0.2s ease-in-out all",
    borderRadius: "6px",
    backgroundColor: "var(--card-bg)",
    border: `1px solid var(--border-color, ${theme.palette.divider})`,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    border: `1px solid var(--accent, ${alpha("rgb(67, 61, 246)", 1)})`,
    // boxShadow: `${alpha("rgb(67, 61, 246)", 0.2)} 0 0 0 0.2rem`,
    outline: `0.2rem solid ${alpha("rgb(67, 61, 246)", 0.2)}`,
  },
  "& .MuiOutlinedInput-root.Mui-error": {
    border: `1px solid var(--error, #D3302F00)`,
    // boxShadow: ` 0 0 0 0.2rem`,
    outline: `0.2rem solid #F005`,
  },

  "& .MuiInputLabel-root": {
    display: "none",
    "&:focus": {
      boxShadow: `${alpha("rgb(67, 61, 246)", 0.25)} 0 0 0 0.2rem`,
      borderColor: "rgb(67, 61, 246)",
    },
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "0.9rem",
    padding: "11px 14px",
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiOutlinedInput-input": {
      fontSize: "0.8rem",
      padding: "10px 12px",
    },
  },
}));
